var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('span',[_vm._v("Copyright © Sonja Roef 2013 All Rights Reserved. No part of this website may be reproduced without Sonja Roef's express consent.")]),_c('span',[_vm._v("designed by Jaak Mannon")])])
}]

export { render, staticRenderFns }